import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App";
import "./index.css";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration()],
  // Capture 20 % of transactions in prod, 100 % locally
  tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0,
  // Record 10 % of sessions, 100 % of sessions with an error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

// Session replay is ~90 kB minified and not needed for first paint — load it
// after init so it lands in its own async chunk.
if (import.meta.env.VITE_SENTRY_DSN) {
  import("@sentry/react")
    .then(({ replayIntegration }) => {
      Sentry.addIntegration(replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }));
    })
    .catch(() => {});
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <div style={{
          minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
          fontFamily: "system-ui, sans-serif", background: "#0f1117", color: "#e4e4e7",
        }}>
          <div style={{ maxWidth: 400, textAlign: "center", padding: "0 24px" }}>
            <div style={{ fontSize: 40, marginBottom: 16 }}>⚠️</div>
            <h1 style={{ fontSize: 20, fontWeight: 600, margin: "0 0 8px" }}>Something went wrong</h1>
            <p style={{ fontSize: 13, color: "#71717a", margin: "0 0 24px" }}>
              {(error as Error)?.message || "An unexpected error occurred."}
            </p>
            <button
              onClick={resetError}
              style={{
                padding: "8px 20px", borderRadius: 6, border: "none",
                background: "#6366f1", color: "#fff", fontSize: 13, fontWeight: 600, cursor: "pointer",
              }}
            >
              Try again
            </button>
          </div>
        </div>
      )}
    >
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
